import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useEditTimeOffStyles = makeStyles()((theme: Theme) => ({
  root: {
    padding: '0px 0px',
    paddingRight: '24px',
  },
  buttonStyle: {
    color: '#611A16',
    fontSize: '14px',
    fontWeight: 500,
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));
